import React from 'react';
import LoadTranslations from "./LoadTranslations";
import TranslationsModel from "../models/TranslationsModel";
import util from "../util/Util";

let loadTranslations = new LoadTranslations();

function withTranslate(WrappedComponent, page = "") {

    const TranslatedComponent = (props) => {

        let t = function (message) {
            let messages = loadTranslations.getMessages();
            let result = message;
            let userLocale = window.localStorage.getItem('currentLanguage');
            let currentLanguage;
            if (userLocale != null) {
                currentLanguage = userLocale;
            } else {
                currentLanguage = "es-ES"
            }
            //Tenemos mensaje traducido
            if (message != null && messages[limpiaString(message)] != null) {
                //messages[message] cuando haya traducciones
                result = messages[limpiaString(message)];
                if (util.esVacio(messages[limpiaString(message)])) {
                    result = message;
                }
            } else {
                if (message != null) {
                    let translation = new TranslationsModel();
                    translation.groupTranslation = "";
                    translation.label = message;
                    translation.message = "";
                    translation.lang = currentLanguage;
                    translation.device = TranslationsModel.WEB;
                    loadTranslations.setMessages(message, message);
                    //translation.persist();
                }
                result = message;
            }
            return result;
        };

        function limpiaString(archivo) {
            archivo.replace(/[áàâãªä]/gi, "a");
            archivo.replace(/[ÁÀÂÃÄ]/gi, "a");
            archivo.replace(/[éèêë]/gi, "e");
            archivo.replace(/[ÉÈÊË]/gi, "e");
            archivo.replace(/[íìîï]/gi, "i");
            archivo.replace(/[ÍÌÎÏ]/gi, "i");
            archivo.replace(/[óòôõºö]/gi, "o");
            archivo.replace(/[ÓÒÔÕÖ]/gi, "o");
            archivo.replace(/[úùûü]/gi, "u");
            archivo.replace(/[ÚÙÛÜ]/gi, "u");
            archivo.replace(/[ñÑ]/gi, "n");
            return archivo.toLowerCase();
        }

        return (
            <WrappedComponent t={t} {...props}>{props.children}</WrappedComponent>
        )

    };

    return TranslatedComponent;
}

export default withTranslate;
